// import Vue from 'vue';
import helpers from './helpersShared';

export default {
  setData(state, payload) {
    state.data = payload.map(helpers.prepareProjectTasksData);
  },
};
